import React from 'react'
import withIcon from '@/components/withIcon'

const IconAllowCellPhones = ({ className }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1360_6278)">
        <g clipPath="url(#clip1_1360_6278)">
          <rect
            x="15"
            y="19"
            width="8"
            height="4"
            fill="#C6D5D8"
          />
          <rect
            x="15"
            y="9"
            width="8"
            height="10"
            fill="white"
          />
          <path
            d="M14 17H2C1.448 17 1 16.552 1 16V2C1 1.448 1.448 1 2 1H20C20.552 1 21 1.448 21 2V9"
            fill="#C6D5D8"
          />
          <path
            d="M14 17H2C1.448 17 1 16.552 1 16V2C1 1.448 1.448 1 2 1H20C20.552 1 21 1.448 21 2V9"
            stroke="#00303E"
            strokeMiterlimit="10"
            strokeLinecap="square"
          />
          <path
            d="M15.8 14H7V4H18V9"
            fill="white"
          />
          <path
            d="M15.8 14H7V4H18V9L17.5266 9.17933C16.7739 9.46442 16.1674 10.0399 15.8433 10.7766L15.8 10.875V12.4375V14Z"
            stroke="#00303E"
            strokeMiterlimit="10"
            strokeLinecap="square"
          />
          <path
            d="M4 10C4.55228 10 5 9.55228 5 9C5 8.44772 4.55228 8 4 8C3.44772 8 3 8.44772 3 9C3 9.55228 3.44772 10 4 10Z"
            fill="#00303E"
          />
          <path
            d="M22 23H16C15.448 23 15 22.552 15 22V10C15 9.448 15.448 9 16 9H22C22.552 9 23 9.448 23 10V22C23 22.552 22.552 23 22 23Z"
            fill="white"
            stroke="#00303E"
            strokeMiterlimit="10"
            strokeLinecap="square"
          />
          <rect
            x="15"
            y="20"
            width="8"
            height="3"
            fill="#C6D5D8"
          />
          <path
            d="M15 20H23"
            stroke="#00303E"
            strokeMiterlimit="10"
            strokeLinecap="square"
          />
          <path
            d="M22 23H16C15.448 23 15 22.552 15 22V10C15 9.448 15.448 9 16 9H22C22.552 9 23 9.448 23 10V22C23 22.552 22.552 23 22 23Z"
            stroke="#00303E"
            strokeMiterlimit="10"
            strokeLinecap="square"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1360_6278">
          <rect
            width="24"
            height="24"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip1_1360_6278">
          <rect
            width="24"
            height="24"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default withIcon(IconAllowCellPhones)
